import { useConfigStore } from "@/features/config"
import type { AppConfig, ConfigParams } from "../types"

export interface UseConfigResult {
  config: AppConfig | null
  configId: string | null
  params: ConfigParams
  status: ReturnType<typeof useConfigStore.getState>["status"]
}

/** React access to the active funnel config. */
export function useConfig(): UseConfigResult {
  const config = useConfigStore((s) => s.config)
  const status = useConfigStore((s) => s.status)
  return {
    config,
    configId: config?.id ?? null,
    params: config?.params ?? {},
    status,
  }
}
